import React from "react";

import { ErrorStateView } from "@common/components/PageStateView/components/ErrorStateView";
import environments from "@common/environments";

export function NotFound() {
  return (
    <ErrorStateView
      title="Page not found"
      subtitle="The link you followed may be broken, or the page may have been removed."
      button={{ url: environments.wwwURL, title: "Return to homepage" }}
    />
  );
}
